import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, Document } from "model";
import React from "react";
import StatementSearchItem from "./classes/StatementSearchItem";

import StatementsPage from "components/pages/StatementsPage";

const steps = [ StatementsPage ];

/**
 * @function StatementSearchWorkflow
 * @returns {React.Component}
 * @description The main workflow component for the statements search widget
 * @exported true
 * @example
 * <StatementSearchWorkflow />
 */
export default function StatementSearchWorkflow(props) {
    const controller = useBCMSContext();
    const value = getDefaultSearch(controller);

    return <Workflow value={ value } steps={ steps } />
}
/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultSearch
 * @returns {OBJECT}
 * @description Return am object with all the info required for the workflow
 * @exported true
 */
export const getDefaultSearch = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);
    let branding = {};
    let options = {}
    let showAllAccountsOption = true;
    const firstAccountID = Account.initAll()[0].id;
    const documents = Document.sortDateAscending(Document.initAll());
    
    if(controller) {
        branding = controller.state.branding;
        options = controller.state.branding.options;
        showAllAccountsOption = options.allaccts_statements_abi22 === "true";
    }

    return {
        data: {
            search: StatementSearchItem.init({ 
                account: showAllAccountsOption ? "all" : `${ firstAccountID }`,
                filtered: showAllAccountsOption ? documents : documents.filter(item => item.account.id === firstAccountID)
            }),
            branding: branding,
        },
        ui: {}
    }
};